import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import LogoOne7Ai from '../../../../assets/img/logo_one7_ai.png';
import './styles.scss';

// Perguntas que exercitam o que o assistente sabe fazer hoje: encontrar telas
// pelo nome e pelo assunto. Servem de exemplo do formato de pergunta esperado.
const SUGESTOES = [
  { icone: '◎', cor: 'ciano', texto: 'Onde fica a tela de mesa de crédito?' },
  { icone: '☰', cor: 'verde', texto: 'Quais telas eu posso acessar?' },
  { icone: '◈', cor: 'ambar', texto: 'Tenho acesso a alguma tela de cobrança?' }
];

/**
 * Primeira tela do chat: identidade, saudacao e caminhos de entrada.
 *
 * As sugestoes enviam a mensagem direto, sem passar pelo input -- por isso
 * aoEscolherSugestao recebe a STRING da pergunta, e nao o evento de clique.
 */
export default function EstadoVazio({ nomeUsuario, aoEscolherSugestao, sugestoes = SUGESTOES }) {
  const saudacao = nomeUsuario ? `Olá, ${nomeUsuario}!` : 'Olá!';
  const sugestoesComEstilo = sugestoes.map(sugestao => ({
    ...sugestao,
    icone: sugestao.icone ?? (sugestao.categoria === 'telas' ? '◎' : '◈'),
    cor: sugestao.cor ?? (sugestao.categoria === 'telas' ? 'ciano' : 'ambar')
  }));

  return (
    <Box className="chat-ia-estado-vazio">
      <Box className="chat-ia-estado-vazio-marca">
        {/* O asset e 308x95: largura fixa com altura automatica preserva a
            proporcao. Forcar um quadrado o esmagaria. */}
        <img src={LogoOne7Ai} alt="One7 ai" className="chat-ia-estado-vazio-logo" />
        <Typography className="chat-ia-estado-vazio-titulo">{saudacao}</Typography>
        <Typography className="chat-ia-estado-vazio-subtitulo">
          Sou o One. Pergunte onde encontrar qualquer tela do sistema e eu levo você até ela.
        </Typography>
      </Box>

      <Box className="chat-ia-sugestoes">
        <Typography className="chat-ia-sugestoes-rotulo">Sugestões</Typography>

        {sugestoesComEstilo.map(sugestao => (
          <Button
            key={sugestao.texto}
            className="chat-ia-sugestao"
            onClick={() => aoEscolherSugestao(sugestao.texto)}
            disableRipple
          >
            <Box
              component="span"
              className={`chat-ia-sugestao-icone chat-ia-sugestao-icone-${sugestao.cor}`}
              aria-hidden="true"
            >
              {sugestao.icone}
            </Box>
            {sugestao.texto}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
